import FilePdf from './FilePdf'

export default FilePdf
// eslint-disable-next-line import/export
export * from './FilePdf'
